import { Tool } from '../../data/tools';

export const metadata: Tool = {
  id: 'hacker-news',
  name: 'Hacker News Daily Reader',
  description: 'Browse the top trending developer articles, startup stories, and technical posts from Hacker News.',
  category: 'Dev',
  icon: 'Globe',
  route: '/tools/hacker-news',
  metaTitle: 'Hacker News Daily Reader — Tech & Startup News Feed',
  metaDescription: 'Read the top 20 trending tech articles, developer posts, and startup stories on Hacker News with direct links, score metrics, and author details.',
  keywords: [
    'hacker news reader',
    'tech news feed',
    'trending developer articles',
    'startup news compiler',
    'ycombinator articles feed',
    'hacker news api online',
    'programming articles list'
  ],
  longDescription: 'The Hacker News Daily Reader queries Y Combinator\'s public Hacker News Firebase API to retrieve the current top 20 stories. It displays author attribution, popularity scores, and comment redirects in a clean, readable developer dashboard.',
  howToUse: [
    'Open the dashboard to automatically load Y Combinator\'s top trending stories.',
    'Click on any article card title to open the external link in a new tab.',
    'Check popularity scores and click "Comments" to open Y Combinator discussions.',
    'Refresh the feed to fetch live updates as stories trend.'
  ],
  benefits: [
    'Pulls real-time trending articles directly from Hacker News servers.',
    'Zero-auth required, loading fully client-side on mobile and desktop.',
    'Clean, ad-free reader environment tailored for developers.'
  ],
  faq: [
    {
      question: 'What is Hacker News?',
      answer: 'Hacker News is a social news website run by Y Combinator focusing on computer science, entrepreneurship, startups, and general technology topics.'
    },
    {
      question: 'How are stories selected for this feed?',
      answer: 'This feed fetches the current top-ranking posts on the Hacker News homepage. The ordering is determined by Y Combinator\'s proprietary ranking algorithm.'
    },
    {
      question: 'How do I read the discussions/comments?',
      answer: 'Each story card includes a link labeled "View YC Discussion". Clicking it redirects you to the official Hacker News comments thread.'
    }
  ]
};
